import { useMemo } from 'react';
import { startCase } from 'lodash';
import FilterDropdown from 'components/elements/Dropdown/FilterDropdown';
import { useAvailableCities } from 'hooks/useUserCityAccess';
import { useCityDocFilter, useRegionFilter } from 'state/filterDocuments';

const CityFilter = () => {
  const { cityFilter, setCityFilter } = useCityDocFilter();
  const { regionFilter } = useRegionFilter();
  const { availableRegions } = useAvailableCities();

  const cityOptions = useMemo(() => {
    if (!regionFilter || regionFilter.length === 0) {
      return [];
    }

    return regionFilter
      .flatMap((regionCode) => availableRegions[regionCode]?.cities || [])
      .filter((city, index, self) => index === self.findIndex((c) => c.id === city.id))
      .map(({ id, name }) => ({
        value: id,
        label: startCase(name.toLowerCase()),
      }));
  }, [availableRegions, regionFilter]);

  const handleChange = (values: string[]) => {
    setCityFilter(values.map((value) => parseInt(value, 10)));
  };

  return (
    <FilterDropdown
      options={cityOptions}
      checkedValues={cityFilter}
      setCheckedValues={handleChange}
      onClearAll={() => setCityFilter([])}
      maxHeight="280px"
      isFilterEnabled
      sortSelectedFirst
    >
      City/Town
    </FilterDropdown>
  );
};

export default CityFilter;
